import { useSelector } from 'react-redux';
import { subscriptionTypeNames } from '../config/subscriptionsConfig';

export default function useIsCompany() {
  const authState = useSelector(state => state.auth);
  const customClaims = authState?.user?.customClaims;

  if (!customClaims) return false;

  const { ownedAgencies, subscriptionType } = customClaims;

  const hasValidSubscription = [
    subscriptionTypeNames.enterprise_1000,
    subscriptionTypeNames.enterprise_unlimited,
    subscriptionTypeNames.admin,
  ].includes(subscriptionType);

  // isCompany
  return ownedAgencies && hasValidSubscription;
}
